import { FC, useEffect, useState } from 'react';
import { TableCell, TextField } from '@material-ui/core';
import { MenuReportItem } from '../../../utils/data/DataMenuReport';
import InputNumberFormat from '../../../components/global/InputNumberFormat';
import TableRowBody from '../../../components/global/TableRowBody';

interface GaugeItemProps {
  item: MenuReportItem;
  onUpdateItem: (item: MenuReportItem) => void;
}

const GaugeItem: FC<GaugeItemProps> = ({ item, onUpdateItem }) => {
  const [currentItem, setCurrentItem] = useState<MenuReportItem>(item);

  const onChange = ({ target }) => {
    setCurrentItem((values) => ({
      ...values,
      [target.name]: target.value,
    }));
  };

  useEffect(() => {
    onUpdateItem(currentItem);
  }, [currentItem]);

  return (
    <TableRowBody>
      <TableCell>{currentItem.title}</TableCell>
      <TableCell>
        <TextField
          id="inputMinimo"
          value={currentItem.minimo}
          size="small"
          name="minimo"
          onChange={onChange}
          InputProps={{
            style: { textAlign: 'right' },
            inputComponent: InputNumberFormat,
          }}
        />
      </TableCell>
      <TableCell>
        <TextField
          id="inputMedio"
          value={currentItem.medio}
          size="small"
          name="medio"
          onChange={onChange}
          InputProps={{
            inputComponent: InputNumberFormat,
          }}
        />
      </TableCell>
      <TableCell>
        <TextField
          id="inputMaximo"
          value={currentItem.maximo}
          size="small"
          name="maximo"
          onChange={onChange}
          InputProps={{
            inputComponent: InputNumberFormat,
          }}
        />
      </TableCell>
    </TableRowBody>
  );
};

export default GaugeItem;
